import { render, staticRenderFns } from "./SaveFilterModal.vue?vue&type=template&id=666ed4f5&scoped=true&"
import script from "./SaveFilterModal.vue?vue&type=script&lang=js&"
export * from "./SaveFilterModal.vue?vue&type=script&lang=js&"
import style0 from "./SaveFilterModal.vue?vue&type=style&index=0&id=666ed4f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666ed4f5",
  null
  
)

export default component.exports